import { request } from "@umijs/max";

export async function getCompanyById(id: number): Promise<any> {
  return request(`/company/${id}`, {
    method: 'GET',
  });
}

export interface CompanyLocation {
  company: string | null;
  name: string | null;
  country: string | null;
  city: string | null;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  facilityType: string | null;
  phone: string | null;
  source: string | null;
  confidence: number | null;
}

export async function getCompanyLocations(foragerId: number): Promise<CompanyLocation[]> {
  return request(`/company/${foragerId}/locations`, {
    method: 'GET',
  });
}

export interface Product {
  id: number;
  name: string;
  packaging_type: string | null;
  category: string | null;
  country_of_origin: string;
  marketer: {
    id: number;
    name: string;
    foragerId: string;
  } | null;
  manufacturer: {
    id: number;
    name: string;
    foragerId: number;
  } | null;
  countries_of_sale: string[];
  ingredients: {
    id: number;
    name: string;
    ins: string | null;
    botanical_name: string | null;
    volume: string | null;
  }[];
}

export async function getCompanyProducts(foragerId: number): Promise<Product[]> {
  return request(`/company/${foragerId}/products`, {
    method: 'GET',
  });
}
